window['ThemeTile'] = (link, title, variantId) => {
  return {
    hover: false,
    link: link,
    title: title,
    variantId: variantId,
    adding: false,
    // Inline option picker state
    optionsOpen: false,
    variants: [],
    selectedOptions: [],
    // Image browsing state
    images: [],
    imgIndex: 0,
    added: false,
    _addedTimer: null,
    init() {
      // Variant map (option-enabled tiles only)
      const dataEl = this.$el.querySelector('[data-tile-variants]');
      if (dataEl) {
        try {
          const parsed = JSON.parse(dataEl.textContent);
          this.variants = parsed.variants || [];
          this.selectedOptions = (parsed.selected || []).slice();
        } catch (e) {
          /* no-op */
        }
      }
      // Image list for the prev/next browser
      const imgEl = this.$el.querySelector('[data-tile-images]');
      if (imgEl) {
        try {
          this.images = JSON.parse(imgEl.textContent) || [];
        } catch (e) {
          /* no-op */
        }
      }
    },
    // ----- Image browsing -----
    prevImage() {
      this._setImage(this.imgIndex - 1);
    },
    nextImage() {
      this._setImage(this.imgIndex + 1);
    },
    _setImage(i) {
      const n = this.images.length;
      if (!n) return;
      this.imgIndex = ((i % n) + n) % n;
      const img = this.$el.querySelector('.tile-media');
      if (img) {
        img.removeAttribute('srcset');
        img.src = this.images[this.imgIndex];
      }
    },
    // ----- Variant resolution -----
    matchedVariant() {
      if (!this.variants.length) return null;
      return (
        this.variants.find((v) =>
          v.options.every((opt, i) => opt === this.selectedOptions[i])
        ) || null
      );
    },
    canAdd() {
      const v = this.matchedVariant();
      return !!(v && v.available);
    },
    openOptions() {
      this.optionsOpen = true;
    },
    showLabel() {
      this.labelContent = this.$refs.labelContent.innerHTML;
      this.focusVisible = this.$refs.tileLink.matches(':focus-visible');
    },
    hideLabel() {
      this.labelContent = '';
      this.focusVisible = false;
    },
    async openQuickView() {
      this.$store.quickview.render(link);
      this.$store.modals.open('productQuickView');
    },
    // ----- Add to cart -----
    async addToCart() {
      if (!this.variantId) return;
      await this._add(this.variantId);
    },
    async addSelected() {
      const v = this.matchedVariant();
      if (!v) return;
      const ok = await this._add(v.id);
      // Keep the panel open briefly so the "Added" feedback is visible, then close.
      if (ok) setTimeout(() => { this.optionsOpen = false; }, 1500);
    },
    async _add(id) {
      if (this.adding) return false;
      this.adding = true;
      try {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('quantity', 1);
        formData.append('sections', 'drawer-cart-items,drawer-cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);

        const url =
          (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ||
          '/cart/add.js';

        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: formData,
        });
        const data = await res.json();

        if (data.status) {
          console.warn('Add to cart rejected', data);
          return false;
        }

        // Show "Added to cart" feedback briefly.
        this.added = true;
        clearTimeout(this._addedTimer);
        this._addedTimer = setTimeout(() => { this.added = false; }, 1800);

        document.body.dispatchEvent(
          new CustomEvent('switch:cart:afteradditem', {
            bubbles: true,
            detail: { response: data },
          })
        );
        return true;
      } catch (e) {
        console.error('Add to cart failed', e);
        return false;
      } finally {
        this.adding = false;
      }
    },
  };
};
